import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "rd-modal-container",
  class: "raise-donors"
}
const _hoisted_2 = ["aria-hidden"]
const _hoisted_3 = { class: "rd-flex-auto rd-overflow-y-auto rd-relative rd-modal-body" }
const _hoisted_4 = {
  key: 0,
  class: "form-step-title"
}
const _hoisted_5 = { class: "rd-relative rd-form-body" }
const _hoisted_6 = {
  key: 1,
  class: "form-step-container"
}

import { AllComponents } from "@/builder/client/AllComponents";
import ButtonComponent from "@/builder/components/button/ButtonComponent.vue";
import ConfirmationRenderContainer from "@/builder/components/form/ConfirmationRenderContainer.vue";
import FormComponent from "@/builder/components/form/FormComponent.vue";
import PromptRenderContainer from "@/builder/components/prompt/PromptRenderContainer.vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import TestModeBanner from "@/components/shared/banner/TestModeBanner.vue";
import { useFocusTrap } from '@vueuse/integrations/useFocusTrap';
import { computed, nextTick, ref } from "vue";
import { ComponentType, ModalDisplayType, PartialDisplayType } from "../../enums";
import TrustCenterContainer from "../trustCenter/TrustCenterContainer.vue";

//props

export default /*@__PURE__*/_defineComponent({
  __name: 'FormModal',
  props: ["showModal", "component", "organizationId", "showModalElements"],
  setup(__props) {

_useCssVars(_ctx => ({
  "223e2ed5": (getFormBackgroundColor.value)
}))

const props = __props;
const renderStore = useRenderStore();

//refs
const showModalElements = ref(props.showModalElements);
const modalType = ref(renderStore.page.pageDesign.modalDisplay);
const modal = ref();
const form = ref();
const formStep = ref();
const isStepTooTall = ref(false);

const { activate, deactivate } = useFocusTrap(modal);

//computed
const getModalLayout = computed(() => {
    return {
        'rd-items-center rd-flex rd-modal-centered': modalType.value == ModalDisplayType.Lightbox,
        'rd-modal-slide-in': modalType.value == ModalDisplayType.Panel
    }
});

const getSubmitButtonPosition = computed(() => {
    return props.component.customData.buttons.submit.customData.alignment &&
        `rd-justify-${props.component.customData.buttons.submit.customData.alignment}`;
});

const getModalAnimation = computed(() => {
    let animationClasses = '';

    if (renderStore.showModal) {
        modalType.value == ModalDisplayType.Lightbox && (animationClasses = 'fade-in');
        modalType.value == ModalDisplayType.Panel && (animationClasses = 'slide-in');
    }
    else {
        modalType.value == ModalDisplayType.Lightbox && (animationClasses = 'fade-out');
        modalType.value == ModalDisplayType.Panel && (animationClasses = 'slide-out');
    }

    return animationClasses;
});

const currentStepTitle = computed(() => {
    const currentStep = renderStore.getFormStepByIndex(renderStore.step);
    if (!currentStep) return null;
    if (!currentStep.customData.displayTitle) return null;
    return currentStep.customData.title;
});

const getFormBackgroundColor = computed(() => {
    const formBgColor = props.component.styles.backgroundColor;
    return formBgColor ? formBgColor : '#FFFFFF';
});

const getScrollbarColor = computed(() => {
    const setColor = props.component.styles.backgroundColor;
    let scrollbarColor;

    if (setColor === '#878787' || setColor === 'rgb(135, 135, 135)') {
        scrollbarColor = '#FFFFFF #878787';
    }
    else if (!setColor) {
        scrollbarColor = '#878787 #FFFFFF';
    }
    else scrollbarColor = `#878787 ${setColor}`;

    return scrollbarColor;
});

//methods
const getFormStepHeight = (stepNumber: number) => {
    nextTick(() => {
        const stepHeight = formStep.value[stepNumber].children[0].offsetHeight,
            parentHeight = form.value.offsetHeight;

        stepHeight > parentHeight ?
            isStepTooTall.value = true :
            isStepTooTall.value = false;
    });
}

const closeModal = () => {
    if (!renderStore.isProcessing) {
        renderStore.showModal = false;
        document.body.classList.remove('rd-modal-open');

        setTimeout(() => {
            showModalElements.value = false;
            deactivate();
        }, 375);
    }
};

const loadModal = () => {
    renderStore.showModal = true;
    showModalElements.value = true;
    //getFormStepHeight(renderStore.step);

    setTimeout(() => {
        document.body.classList.add('rd-modal-open');
        activate()
    }, 425);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: "modal-button-container rd-flex rd-w-full",
      style: _normalizeStyle({
        justifyContent: __props.component.customData.buttons.modal.customData.alignment
    })
    }, [
      _createVNode(ButtonComponent, {
        component: __props.component.customData.buttons.modal,
        onClick: _withModifiers(loadModal, ["stop"])
      }, null, 8, ["component"])
    ], 4),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["rd-h-full rd-left-0 rd-overflow-x-hidden rd-overflow-y-auto rd-fixed rd-top-0 rd-w-full rd-modal", showModalElements.value ? 'rd-block' : 'rd-hidden']),
          id: "rd-modal",
          tabindex: "-1",
          role: "dialog",
          "aria-label": "Giving Form Modal",
          "aria-hidden": showModalElements.value ? false : true,
          ref_key: "modal",
          ref: modal,
          onClick: _withModifiers(closeModal, ["stop"])
        }, [
          (_unref(renderStore).page.partialDisplayType === _unref(PartialDisplayType).Modal)
            ? (_openBlock(), _createBlock(TestModeBanner, {
                key: 0,
                source: "public"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            class: _normalizeClass(["rd-pointer-events-none rd-relative rd-w-auto rd-modal-wrapper rd-modal-scroll md:rd-modal-full", [getModalLayout.value, getModalAnimation.value]]),
            role: "document",
            ref: "el"
          }, [
            _createElementVNode("div", {
              class: "rd-modal-content",
              style: _normalizeStyle({ backgroundColor: __props.component.styles.backgroundColor })
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("section", null, [
                  (__props.component.customData.modalImage)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "rd-modal-image",
                        style: _normalizeStyle({ 'background-image': 'url(' + __props.component.customData.modalImage + ')' })
                      }, null, 4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["rd-modal-form", __props.component.styles?.cssClass]),
                    style: _normalizeStyle({
                                    backgroundColor: __props.component.styles.backgroundColor,
                                    color: __props.component.styles.fontColor
                                })
                  }, [
                    _createElementVNode("header", {
                      class: _normalizeClass(["rd-items-center rd-flex rd-shrink-0 rd-modal-header rd-modal-header-gradient", { 'with-image': __props.component.customData.modalImage }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.components.filter(x => x.type === _unref(ComponentType).FormStep), (item, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (index === _unref(renderStore).step)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_unref(renderStore).step > 0 && !_unref(renderStore).success)
                                  ? (_openBlock(), _createBlock(ButtonComponent, {
                                      key: 0,
                                      "aria-label": "Go to previous step",
                                      component: item.customData.buttons.prev
                                    }, null, 8, ["component"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      (currentStepTitle.value && !_unref(renderStore).success)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", null, _toDisplayString(currentStepTitle.value), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "rd-btn-close",
                        "aria-label": "Close",
                        onClick: [
                          _withModifiers(closeModal, ["stop"]),
                          _cache[0] || (_cache[0] = ($event: any) => (_unref(deactivate)()))
                        ]
                      }, _cache[2] || (_cache[2] = [
                        _createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1)
                      ]))
                    ], 2),
                    _createElementVNode("section", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "default", {}, () => [
                        (!_unref(renderStore).success)
                          ? (_openBlock(), _createElementBlock("form", {
                              key: 0,
                              name: "rd-form",
                              method: "post",
                              style: _normalizeStyle({ 'scrollbar-color': getScrollbarColor.value })
                            }, [
                              _createVNode(FormComponent, null, {
                                children: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.components.filter(x => x.type === _unref(ComponentType).FormStep), (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: _normalizeClass(["rd-h-full", index === _unref(renderStore).step ? 'rd-block' : 'rd-hidden']),
                                      ref_for: true,
                                      ref_key: "formStep",
                                      ref: formStep
                                    }, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[item.type]), { component: item }, null, 8, ["component"]))
                                    ], 2))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ], 4))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (props.component.components.filter(x => x.type === _unref(ComponentType).Confirmation).length > 0)
                                ? (_openBlock(), _createBlock(ConfirmationRenderContainer, {
                                    key: 0,
                                    component: props.component.components.filter(x => x.type === _unref(ComponentType).Confirmation)[0],
                                    style: _normalizeStyle({ 'scrollbar-color': getScrollbarColor.value })
                                  }, null, 8, ["component", "style"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[3] || (_cache[3] = [
                                    _createElementVNode("div", { class: "layout-row" }, [
                                      _createElementVNode("div", { class: "rd-w-full md:rd-flex-equal" }, [
                                        _createElementVNode("h1", null, "Thank you for your donation!")
                                      ])
                                    ], -1)
                                  ])))
                            ], 64))
                      ])
                    ]),
                    (!_unref(renderStore).success)
                      ? (_openBlock(), _createElementBlock("footer", {
                          key: 0,
                          class: _normalizeClass(["rd-modal-footer rd-modal-footer-gradient", { 'with-image': __props.component.customData.modalImage }])
                        }, [
                          (_unref(renderStore).maxSteps > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_unref(renderStore).step === _unref(renderStore).maxSteps)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(['rd-flex rd-w-full', getSubmitButtonPosition.value])
                                    }, [
                                      (_unref(renderStore).step === _unref(renderStore).maxSteps)
                                        ? (_openBlock(), _createBlock(ButtonComponent, {
                                            key: 0,
                                            component: __props.component.customData.buttons.submit,
                                            disabled: _unref(renderStore).hasErrors,
                                            onClick: _unref(renderStore).isProcessing
                                          }, {
                                            buttonText: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(__props.component.customData.buttons.submit.customData.text) + " " + _toDisplayString(_unref(renderStore).submitButtonAmount), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["component", "disabled", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.components.filter(x => x.type === _unref(ComponentType).FormStep), (item, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (index === _unref(renderStore).step)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["rd-flex rd-w-full", item.customData.buttons.next.customData.alignment && `rd-justify-${item.customData.buttons.next.customData.alignment}`])
                                        }, [
                                          (_unref(renderStore).step !== _unref(renderStore).maxSteps)
                                            ? (_openBlock(), _createBlock(ButtonComponent, {
                                                key: 0,
                                                component: item.customData.buttons.next,
                                                disabled: _unref(renderStore).stepHasErrors(_unref(renderStore).step)
                                              }, null, 8, ["component", "disabled"]))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["rd-flex rd-w-full", getSubmitButtonPosition.value])
                              }, [
                                _createVNode(ButtonComponent, {
                                  component: __props.component.customData.buttons.submit,
                                  disabled: _unref(renderStore).hasErrors,
                                  onClick: _unref(renderStore).isProcessing
                                }, {
                                  buttonText: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.component.customData.buttons.submit.customData.text) + " " + _toDisplayString(_unref(renderStore).submitButtonAmount), 1)
                                  ]),
                                  _: 1
                                }, 8, ["component", "disabled", "onClick"])
                              ], 2))
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 6)
                ])
              ]),
              _createElementVNode("div", {
                class: "trust-center-modal",
                style: _normalizeStyle({ backgroundColor: __props.component.styles.backgroundColor })
              }, [
                _createVNode(TrustCenterContainer, {
                  page: _unref(renderStore).page,
                  "tooltip-container": ".trust-center-modal"
                }, null, 8, ["page"])
              ], 4),
              _createVNode(PromptRenderContainer)
            ], 4)
          ], 2)
        ], 10, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass(["rd-modal-backdrop", [_unref(renderStore).showModal ? 'fade-in-backdrop' : 'fade-out-backdrop', { 'rd-hidden': !showModalElements.value }]])
        }, null, 2)
      ])
    ]))
  ], 64))
}
}

})